import { useCallback, useEffect } from 'react';

import { matomoProvider, tracker } from '@femtasy/helpers';

import { isProduction } from 'helpers/env';

export interface TrackPageViewParams {
  href?: string;
  documentTitle?: string;
}

export interface TrackSiteSearchParams {
  keyword: string;
  category: string;
  count: number;
}

export const pushInstruction = (operationName: string, ...args: any[]) => {
  tracker.sendEvent(operationName, args, !isProduction(), [matomoProvider]);
};

export const trackSiteSearch = ({
  keyword,
  category,
  count,
}: TrackSiteSearchParams) => {
  tracker.sendEvent(
    'trackSiteSearch',
    [keyword, category, count],
    !isProduction(),
    [matomoProvider],
  );
};

export const useTracking = () => {
  const trackContentInteraction = useCallback(
    (action: string, name: string, piece: string, target?: string) => {
      tracker.sendEvent(
        'trackContentInteraction',
        [action, name, piece, target],
        !isProduction(),
        [matomoProvider],
      );
    },
    [],
  );

  const trackContentImpression = useCallback(
    (name: string, piece: string, target: string) => {
      tracker.sendEvent(
        'trackContentImpression',
        [name, piece, target],
        !isProduction(),
        [matomoProvider],
      );
    },
    [],
  );

  const trackPageViewWrapper = useCallback(({ href }: TrackPageViewParams) => {
    tracker.pageView(window.document.title, href);
  }, []);

  return {
    trackContentInteraction,
    trackContentImpression,
    trackPageView: trackPageViewWrapper,
  };
};

export const useTrackPageView = (url: string) => {
  useEffect(() => {
    tracker.pageView(window.document.title, url);
  }, [url]);
};
